import { type SagaIterator } from '@redux-saga/core';
import { call, put, takeEvery } from 'redux-saga/effects';

import getCountry from '../../services/country/country.api'
import { type Country} from '../../types/country';
import { countryActions } from './slice';

// Worker Sagas
export function* onGetCountry(): SagaIterator {
    try {
        const countries: Country[] = yield call(getCountry);
        yield put(countryActions.fetchAllSucceeded(countries));
    } catch (e: unknown) {
        if (e instanceof Error) {
            yield put(countryActions.fetchAllFailure(e.message.toString()));
        }
    }
}

// Watcher Saga
function* countryWatcherSaga(): SagaIterator {
    yield takeEvery(countryActions.fetchAll.type, onGetCountry);
}

export default countryWatcherSaga;